import { Typography } from 'antd';

import { HoverCopy } from '../../Components/Common';

export default function getRender(field) {
  const renderMap = {
    copyable: (text) => <Typography.Paragraph copyable>{text}</Typography.Paragraph>,
    hover: (text) => <HoverCopy text={text} />
  };
  return renderMap?.[field];
}
